import DiceAttribute from './diceAttribute';

export default class Element extends DiceAttribute {
  public isProctection = false;

  public constructor(name: string, isProtection: boolean) {
    super(name);
    this.isProctection = isProtection;
  }

  public getClone() {
    const clone = new Element(this.name, this.isProctection);
    clone.numDice = this.numDice;
    clone.numBonus = this.numBonus;
    return clone;
  }
}
